import Company, {CompanyDTO} from "@/model/company";
import api from "./api";
import PaginateModel, {PaginateDTO} from "@/model/paginate";
import CompanyCooperate from "@/model/companyCooperate";

interface CompanyListResponseInterface {
  meta: string;
  data: {
    data: CompanyDTO[];
    pagination: any;
  };
}

interface CompanyList {
  paginate: PaginateDTO;
  list: Company[];
}

class CompanyApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async list(query = {}): Promise<Company[]> {
    const response = await this.getHttp().get<any>("/companies",
      {
        params: query
      });
    if (response.status === 200) {
      return response.data.data.map((item) => {
        return new Company(item);
      });
    }
  }

  async index(query): Promise<CompanyList> {
    const response = await this.getHttp().get<CompanyListResponseInterface>(
      "/partners",
      {
        params: query,
      }
    );

    if (response.status !== 200) {
      return;
    }

    const list = response.data.data.data.map((item) => {
      return new Company(item);
    });
    const paginate = new PaginateModel({
      page: response.data.data.pagination.current_page,
      pageCount: response.data.data.pagination.last_pages,
      start: response.data.data.pagination.current_page,
      end: response.data.data.pagination.last_pages,
      count: response.data.data.pagination.total,
    });
    return {
      list,
      paginate,
    };
  }

  async show(id): Promise<any> {
    const response = await this.getHttp().get<any>("/companies/" + id);

    if (response.status === 200) {
      return response.data;
    }
  }

  async getPartnerDetail(id): Promise<any> {
    const response = await this.getHttp().get<any>("/partners/" + id);

    if (response.status === 200) {
      return response.data;
    }
  }

  async updateIsAllowLink(company: Company): Promise<Company> {
    const response = await this.getHttp().put<any>(
      "/partners/update-is-allow-link/" + company.id,
      company
    );

    if (response.status === 200) {
      return new Company(response.data.data);
    }
  }

  async deleteCooperate(id): Promise<any> {
    const response = await this.getHttp().delete<any>(
      "/partners/cooperate/" + id,
    );

    return response.data;
  }

  async createCooperate(companyCooperate: CompanyCooperate): Promise<any> {
    const cooperateData = this.tranformCooperateData(companyCooperate);
    const response =  await this.getHttp().post<any>("/partners/cooperate" , cooperateData);

    return response.data;
  }

  async updateCooperate(companyCooperate: CompanyCooperate): Promise<any> {
    const cooperateData = this.tranformCooperateData(companyCooperate);
    const response = await this.getHttp().put<any>(
      "/partners/cooperate/" + companyCooperate.id,
      cooperateData
    );

    return response.data;
  }

  public tranformCooperateData(companyCooperate: CompanyCooperate)
  {
    return {
      company_id: companyCooperate.company_id,
      cooperate_company_id: companyCooperate.cooperate_company_id,
      role_id: companyCooperate.role_id,
    }
  }

  async deleteCompany(id): Promise<any> {
    return await this.getHttp().delete<any>("/companies/" + id);
  }

  async create(company: Company, parentCompanyId = null): Promise<any> {
    const dataCompany = this.tranformRequest(company, parentCompanyId);
    const response = await this.getHttp().post<any>("/companies/" , dataCompany);

    return response.data;
  }

  public tranformRequest(company, parentCompanyId = null) {
    const dataTranform = Object.assign({}, company);

    delete dataTranform.representative_user_id;
    delete dataTranform.representative_user;
    delete dataTranform.cooperate_count;
    delete dataTranform.companies_cooperate;

    if (parentCompanyId && parentCompanyId.trim() !== "") {
      dataTranform.parent_company_id = parentCompanyId;
    }
    return dataTranform;
  }

  async update(company: Company): Promise<any> {
    const response = await this.getHttp().put<any>("/companies/" + company.id, company);

    return response.data;
  }

  async storeLicense(company: Company): Promise<any> {
    const response = await this.getHttp().put<any>("/license/" + company.id, company);

    return response.data;
  }
}
export default new CompanyApi();
